import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { EoBaseFormControlComponent } from '../eo-base-form-control/eo-base-form-control.component';
import { IEoDatepickerConfig } from './eo-date-picker.model';

@Component({
  selector: 'eo-date-picker',
  templateUrl: './eo-date-picker.component.html',
  styleUrl: './eo-date-picker.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoDatePickerComponent),
      multi: true,
    },
  ],
})
export class EoDatePickerComponent extends EoBaseFormControlComponent {
  protected override _config?: IEoDatepickerConfig;
  override get config() {
    return this._config;
  }
  override set config(val: IEoDatepickerConfig | undefined) {
    this._config = val;
  }

  @Input() dateFormat?: string;
  @Input() minDate?: Date;
  @Input() maxDate?: Date;
  @Input() icon?: string;
  @Input() datePickerStyleClass?: string;
  @Input() placeholder?: string;
  @Input() loadingPlaceholder?: string;
  @Input() showClear?: boolean;
  @Input() showIcon?: boolean;
  @Input() showOnFocus?: boolean;
  @Input() showButtonBar?: boolean;
  @Input() appendTo: any;
  @Input() formatValueToUtcOnChange?: boolean;

  _showTime?: boolean;
  @Input() set showTime(val: boolean | undefined) {
    this._showTime = val;
  }
  get showTime(): boolean {
    if (this._showTime != undefined) return this._showTime;
    return this.config?.showTime ?? false;
  }

  _timeOnly?: boolean;
  @Input() set timeOnly(val: boolean | undefined) {
    this._timeOnly = val;
  }
  get timeOnly(): boolean {
    if (this._timeOnly != undefined) return this._timeOnly;
    return this.config?.timeOnly ?? false;
  }

  showInputIcon = new BehaviorSubject<boolean>(true);
  handleIconChange(): Observable<boolean> {
    if (this.formControl) {
      this.formControl.valueChanges.subscribe((value) => {
        this.showInputIcon.next(!value);
      });
    }

    return this.showInputIcon;
  }

  protected onSelect(event$: Date): void {
    console.log(event$.toISOString());
    if (event$ instanceof Date && !isNaN(event$.getTime())) {
      if (!this.showTime || this.formatValueToUtcOnChange) {
        this.formControl.setValue(
          new Date(
            Date.UTC(event$.getFullYear(), event$.getMonth(), event$.getDate())
          )
        );
      }
      this.change.emit();
    } else {
      console.warn('Invalid date value in event$');
    }
  }

  protected getDateFormat(): string {
    return this.dateFormat ?? this.config?.dateFormat ?? 'dd/mm/yy';
  }
  protected getMinDate(): Date | null {
    return this.minDate ?? this.config?.minDate ?? null;
  }

  protected getMaxDate(): Date | null {
    return this.maxDate ?? this.config?.maxDate ?? null;
  }

  protected getIcon(): string {
    return this.icon ?? this.config?.icon ?? '';
  }
  protected getShowIcon(): boolean {
    return this.showIcon ?? this.config?.showIcon ?? true;
  }
  protected getShowButtonBar(): boolean {
    return this.showButtonBar ?? this.config?.showButtonBar ?? false;
  }
  protected getDatePickerStyleClass(): string {
    return this.datePickerStyleClass ?? this.config?.datePickerStyleClass ?? '';
  }
  protected getPlaceholder(): string {
    if (this.loading)
      return this.loadingPlaceholder ?? this.config?.loadingPlaceholder ?? '';

    return this.placeholder ?? this.config?.placeholder ?? '';
  }
  protected getLoadingPlaceholder(): string {
    return (
      this.loadingPlaceholder ??
      this.config?.loadingPlaceholder ??
      'Παρακαλώ περιμένετε...'
    );
  }
  protected getShowOnFocus(): boolean {
    return this.showOnFocus ?? this.config?.showOnFocus ?? true;
  }
  protected getShowClear(): boolean {
    return this.showClear ?? this.config?.showClear ?? false;
  }
  protected getAppendTo(): any {
    return this.appendTo ?? this.config?.appendTo ?? '';
  }
}
